import { ApplicationQuestionnaireSections } from './application-questionnaire-sections';
import { Applicant } from '../interfaces/applicant';
import { Meeting, MeetingAgent, MeetingIndividual, MeetingLocation } from './meeting';

/**
 * Create a new FormSubmission object for/from the forms project
 */
abstract class FormSubmissionData {
  // public additionalInformation = '';
  public section_notes?: SectionNotes;
  public form='';
  public applicant!:Applicant;
  public partner!:Applicant;
  public meeting!:Meeting;
  constructor(data?: Partial<FormSubmissionData>) {
    if (data) Object.assign(this, data);
  }

  /**
   * Set the section notes property using the keys from the provided object
   * @param {FormSubmissionType} data - The object to use to set the section notes property
   * @returns {SectionNotes}
   */
  public getSectionNotes(data: FormSubmissionType): SectionNotes {
    // Set the section notes property using the keys from the provided object
    return Object.keys(data).reduce((acc, key) => {
      // Set the section notes object key to an empty string
      acc[key as keyof FormSubmissionType] = '';

      // Return the section notes object
      return acc;
    }, {} as SectionNotes);
  }
}

/**
 * A client profile form used for....
 */
export class ClientProfile extends FormSubmissionData {
  public additionalInformation = '';
  public confidenceLevel = '';
  public emotionTemperatureWhy = '';
  public firstName = ''
  public lastName = ''
  public ltcInsurance = '';
  public retirementAssets = '';
  public selfEmployedHsa = '';
  public applicant!:Applicant;
  public partner!:Applicant;
  constructor(data?: ClientProfile) {
    super(data);
    if (data) Object.assign(this, data);
  }
}

/**
 * A basic contact form used for....
 */
export class BasicContact extends FormSubmissionData {
  public details = '';
  public fixedIncome = '';
  public emotionTemperature = '';
  public clientConfidence = '';

  constructor(data?: BasicContact) {
    super(data);
    if (data) Object.assign(this, data);
  }
}

/**
 * A consultation summary between an Agent and Customers used for....
 */
export class ConsultationSummary extends FormSubmissionData {
  public consultation_summary = '';

  constructor(data?: ConsultationSummary) {
    super(data);
    if (data) Object.assign(this, data);
  }
}

/**
 * A health questionnaire form used for....
 */
export class HealthQuestionnaire extends FormSubmissionData {
  constructor(data?: HealthQuestionnaire) {
    super(data);
    if (data) Object.assign(this, data);
  }
}

/**
 * An agreement form for new groups and their employees/agents
 */
export class Agreement extends FormSubmissionData {
  public group_name = '';
  public advisor_network = '';

  constructor(data?: Agreement) {
    super(data);
    if (data) Object.assign(this, data);
  }
}

/**
 * AP-Meetings Education
 */
export class Meetings extends FormSubmissionData {
  public firstName = '';
  public lastName = '';
  public email = '';
  public birthDate = '';
  public agent?: MeetingAgent;
  public client?: MeetingIndividual;
  public location?: MeetingLocation;
  constructor(data?: Meetings) {
    super(data);
    if (data) Object.assign(this, data);
  }
}


/**
 * Section notes should include a key/value pair for each section of the form
 */
export type SectionNotes = {
  [key in keyof FormSubmissionType]: any;
};

/**
 * An applicant health form used for....
 */
export class ApplicantHealth extends FormSubmissionData {
  public occupation = '';
  public occupationDescription = '';
  public license = '';
  public licenseStateIssuer = '';
  public milesDrivenAnnually = '';
  public currentHeight = '';
  public currentWeight = '';
  public previousHeight = '';
  public previousWeight = '';
  public unplannedWeightLoss = false;
  public applicationQuestionnaire!: ApplicationQuestionnaireSections;

  constructor(data?: ApplicantHealth) {
    super(data);
    if (data) Object.assign(this, data);
  }
}

/**
 * A simple form that does not include any properties other than the default.
 */
export class SimpleForm extends FormSubmissionData {

  constructor(data?: SimpleForm) {
    super(data);
    if (data) Object.assign(this, data);
  }
}

/**
 * A union of all FormSubmission data types
 */
export type FormSubmissionType = SimpleForm | HealthQuestionnaire | ClientProfile | ConsultationSummary | ApplicantHealth | Agreement | BasicContact | Meetings;
